import type { SessionData } from '@/lib/api';
import { IdlePanel } from './IdlePanel';

export function IdleBanner({ session }: { session?: SessionData | null }) {
  return <IdlePanel session={session} />;
}
